'use es6';

import { MODULE_PLACEHOLDER_CLASS } from 'InpageEditorUI/lib/dom';
export function widgetPlaceholder(params) {
  const {
    placeholder,
    imgsrc,
    extraClass
  } = params;
  const img = imgsrc ? `<img src="${imgsrc}"` : '';
  return `<div class="${MODULE_PLACEHOLDER_CLASS} ${extraClass}"><div>${placeholder}${img}</div></div>`;
}
export function addModule(params) {
  const {
    cellId,
    order
  } = params;
  return `<div class="hs-ipe-add-placeholder" data-order="${order}" data-cell-id="${cellId}"></div>`;
}
export function dropPlaceholder(params) {
  const {
    cellId,
    order
  } = params;
  return `<div class="hs-ipe-drop-placeholder" data-order="${order}" data-cell-id="${cellId}"></div>`;
}
export function flexColumnDropPlaceholder(params) {
  const {
    columnId,
    order
  } = params;
  return `<div class="hs-ipe-drop-placeholder" data-order="${order}" data-column-id="${columnId}"></div>`;
}
export function layoutControlBox(params) {
  const {
    iconBadgeScale,
    marginOffset,
    id
  } = params;
  return `
    <div id="${id}" class="hs-ipe-layout-control hs-ipe-overlay" draggable="true">
      <div class="pre-icon move" style="font-size: ${iconBadgeScale / 2}px; border-radius: ${iconBadgeScale}px; height: ${iconBadgeScale}px; width: ${iconBadgeScale}px; margin-top: ${marginOffset}px;"></div>
    </div>
  `;
}